import React from 'react';
import styled from 'styled-components';
import selected_box from './assets/select-box.svg';
import selected_box_active from './assets/select-box-active.svg';
type Props = {
  value?: boolean;
  onClick?: () => void;
  onChange?: (value: boolean) => void;
  label?: string;
};
const RequestInput = ({ value, onClick, onChange, label }: Props) => {
  const handleChange = () => {
    if(onClick) return onClick?.();
    onChange?.(!value);
  };

  return (
    <Container type='button' onClick={handleChange}>
      <img src={value ? selected_box_active : selected_box} alt="selected_box" />
      <span>{label}</span>
    </Container>
  );
};

export default RequestInput;
const Container = styled.button`
display: flex;
padding: 8px 0;
align-items: center;
gap: 8px;
span {
  color: #2463EB;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
img {
  width: 24px;
  height: 24px;
  aspect-ratio: 1/1;
}
`;